document.addEventListener('DOMContentLoaded', function() {
    const modal = document.querySelector('#modalOrderPromo');
    if (modal) {
        const pathname = window.location.pathname;
        if (user.discountAvailableOnFirstOrder
            && (pathname === '/'
                || pathname.startsWith('/personal/basket/')
                || pathname.startsWith('/catalog/')
                || pathname.startsWith('/ebookcatalog/')
                || pathname.startsWith('/audiobookcatalog/')
                || pathname.startsWith('/blog/'))) {
            init();
        }
        
        function init() {
            const reminder = document.querySelector('.js-order-promo-reminder');
            let reminderVisible;
            const $modal = $(modal);
            const before = modal.querySelector('.js-order-promo-before');
            const after = modal.querySelector('.js-order-promo-after');
            const auth = modal.querySelector('.js-order-promo-auth');
            const field = modal.querySelector('.js-order-promo-field');
            const copy = modal.querySelector('.js-order-promo-copy');
            let modalStatePromoShown = false;
            
            const initialTopPositionMobile = 67;
            const minimumMarginFromHeaderMobile = 20;
            const resizeThrottleInterval = 200;
            
            const recalcReminderPosition = function() {
                const isDesktop = window.innerWidth >= globObj.breakpoints.lg;
                let reminderPosition;
                if (!isDesktop) {
                    reminderPosition = initialTopPositionMobile;
                    if ('Header' in window) {
                        const headerVisibleHeight = Header.getHeightOnScreen(true);
                        const deltaWithHeader = initialTopPositionMobile - headerVisibleHeight;
                        if (deltaWithHeader <= minimumMarginFromHeaderMobile) {
                            reminderPosition = headerVisibleHeight + minimumMarginFromHeaderMobile;
                        }
                    }
                    reminder.style.top = `${reminderPosition}px`;
                } else {
                    reminder.style.top = '';
                }
            };
            const showReminder = function() {
                recalcReminderPosition();
                reminder.classList.add('order-promo-reminder_active');
                reminderVisible = true;
                document.body.classList.add('body_global-hasFirstOrderPromo');
            };
            const hideReminder = function() {
                reminder.classList.remove('order-promo-reminder_active');
                reminderVisible = false;
            };
            const setModalState = function(isPromoShown = false) {
                modalStatePromoShown = isPromoShown;
                if (isPromoShown) {
                    before.style = 'display: none;';
                    after.style = 'display: block;';
                } else {
                    before.style = 'display: block;';
                    after.style = 'display: none;';
                }
            };
            const showModal = function(customSettings = {}) {
                const defaultSettings = {
                    afterClose: function(instance, slide) {
                        showReminder();
                        localStorage.setItem('ab_order_promo_collapse', '1');
                    },
                    btnTpl: {
                        smallBtn:
                            '<button data-fancybox-close class="fancybox-modal-close-custom" title="{{CLOSE}}">' +
                            '<svg fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                            '<rect width="20.5702" height="2.05702" rx="1.02851" transform="matrix(0.707104 0.707109 -0.707104 0.707109 1.4541 0.000244141)" fill="#FFFFFF"/>\n' +
                            '<rect width="20.5702" height="2.05702" rx="1.02851" transform="matrix(0.707104 -0.707109 0.707104 0.707109 0.000976562 14.5454)" fill="#FFFFFF"/>\n' +
                            '</svg>' +
                            '</button>'
                    }
                };
                const settings = {};
                Object.assign(settings, defaultSettings, customSettings)
                $modal.iModalOpen(settings);
                
                $(document).trigger('yaEvent', [(modalStatePromoShown) ? 'show_popap_promocode_for_first_order' : 'show_popap_bonus_for_first_order']);
            };
            const onCopyShowTooltip = function(content) {
                $(field).tooltipster({
                        content: content,
                        contentAsHTML: true,
                        delay: 100,
                        debug: false,
                        functionAfter: function(instance, helper) {
                            instance.destroy()
                        },
                        interactive: true,
                        maxWidth: 300,
                        trigger: 'custom',
                        triggerClose: {
                            mouseleave: true,
                            click: true,
                            tap: true
                        },
                        zIndex: 99999
                    })
                    .tooltipster('open')
            };
            const onCopySuccess = function() {
                onCopyShowTooltip('Промокод скопирован в буфер обмена');
            };
            const onCopyFail = function() {
                onCopyShowTooltip('Не удалось скопировать. Попробуйте вручную.');
            };
            const copyPromo = async(text) => {
                if ('clipboard' in navigator) {
                    await navigator.clipboard.writeText(text).then(() => {
                            onCopySuccess();
                        })
                        .catch(() => {
                            onCopyFail();
                        });
                } else {
                    onCopyFail();
                }
            };
            
            // события для плашки-ремайндера
            const throttleResize = globalFunctions.throttle(function(event){
                recalcReminderPosition();
            }, resizeThrottleInterval);
            window.addEventListener('resize', throttleResize);
            window.addEventListener('scroll', recalcReminderPosition);
            document.addEventListener('banner.alert.shown', recalcReminderPosition);
            document.addEventListener('banner.alert.hidden', recalcReminderPosition);
            reminder.addEventListener('click', event => {
                event.preventDefault();
                hideReminder();
                showModal();
            });
            $modal.on('is:open', event => {
                hideReminder();
            });
    
            // событие при клике на кнопку "Получить промокод"
            auth.addEventListener('click', event => {
                window.onLoginBubbleToOrderPromo = true;
                $(document).trigger('yaEvent', ['clickonbutton_popap_bonus_for_first_order']);
            });
    
            // обработка успешной авторизации
            $(document).on('userLogin:after',function (event) {
                if (!window.onLoginBubbleToBasket
                    && window.onLoginBubbleToOrderPromo
                    && window.discountAvailableOnFirstOrder) {
                    setModalState(true);
                    showModal({
                        beforeClose: function(instance, current, event) {
                            setTimeout(function() {
                                document.location.reload();
                            }, 100);
                            return false;
                        }
                    });
                }
            });
    
            // копирование промокода
            copy.addEventListener('click', event => {
                event.preventDefault();
                copyPromo(field.innerText);
    
                $(document).trigger('yaEvent', ['clickonbutton_copypromocode_for_first_order']);
            });
            
            // инициализация на загрузке
            let showModalOpened = false;
            if (pathname.startsWith('/personal/basket/') && localStorage.getItem('ab_order_promo_basket_opened') !== '1') {
                showModalOpened = true;
                localStorage.setItem('ab_order_promo_basket_opened', '1');
            } else if (localStorage.getItem('ab_order_promo_collapse') !== '1') {
                showModalOpened = true;
            }
            setModalState(user.userLogged);
            
            // показ модального окна или плашки справа
            if (showModalOpened) {
                setTimeout(function() {
                    showModal();
                }, 3000);
            } else {
                setTimeout(function() {
                    showReminder();
                }, 1000);
            }
        }
    }
});
